import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { WidgetPagesEntity, OldWidgetsEntity } from './widget-pages.models'

export const loadWidgetPages = createAction('[WidgetPages Page] Load WidgetPages/Widgets')

export const loadWidgetPagesSuccess = createAction(
  '[WidgetPages/API] Load WidgetPages Success',
  props<{ widgetPages: WidgetPagesEntity[] }>(),
)

export const loadWidgetPagesFailure = createAction(
  '[WidgetPages/API] Load WidgetPages Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadOldWidgets = createAction('[WidgetPages Page] Load Old Widgets')

export const loadOldWidgetsSuccess = createAction(
  '[WidgetPages/API] Load Old Widgets Success',
  props<{ old_widgets: OldWidgetsEntity[] }>(),
)

export const loadOldWidgetsFailure = createAction(
  '[WidgetPages/API] Load Old Widgets Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectWidgetPage = createAction('[WidgetPages Page] Select Widget Page', props<{ uuid?: string }>())

export const clearSelectedWidgetPage = createAction('[WidgetPages Page] Clear Selected Widget Page')

export const addWidgetPage = createAction(
  '[WidgetPages Page] Add Widget Page',
  props<{ widgetPage: Partial<WidgetPagesEntity>; onSuccess?: (uuid: string) => void }>(),
)

export const addWidgetPageSuccess = createAction(
  '[WidgetPages/API] Add Widget Page Success',
  props<{ widgetPage: WidgetPagesEntity; onSuccess?: (uuid: string) => void }>(),
)

export const addWidgetPageFailure = createAction(
  '[WidgetPages/API] Add Widget Page Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateWidgetPage = createAction(
  '[WidgetPages Page] Update Widget Page',
  props<{ widgetPage: Partial<WidgetPagesEntity>; onSuccess?: () => void }>(),
)

export const updateWidgetPageSuccess = createAction(
  '[WidgetPages/API] Update Widget Page Success',
  props<{ widgetPage: WidgetPagesEntity; onSuccess?: () => void }>(),
)

export const updateWidgetPageFailure = createAction(
  '[WidgetPages/API] Update Widget Page Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteWidgetPage = createAction('[WidgetPages Page] Delete Widget Page', props<{ uuid: string }>())

export const deleteWidgetPageSuccess = createAction(
  '[WidgetPages/API] Delete Widget Page Success',
  props<{ uuid: string }>(),
)

export const deleteWidgetPageFailure = createAction(
  '[WidgetPages/API] Delete Widget Page Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const goToAddOrEditWidgetPage = createAction(
  '[WidgetPages Page] Navigate to add or edit Widget Page',
  props<{ uuid?: string; newTab?: boolean | undefined }>(),
)

export const syncWidgetPage = createAction('[WidgetPages/API] Sync Widget Page', props<{ uuid: string }>())

export const syncWidgetPageSuccess = createAction(
  '[WidgetPages/API] Sync Widget Page Success',
  props<{ widgetPage: WidgetPagesEntity }>(),
)

export const syncWidgetPageFailure = createAction(
  '[WidgetPages/API] Sync Widget Page Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const dismissWidgetPagesHomepageHint = createAction('[WidgetPages Page] Dismiss WidgetPages Homepage Hint')

export const goToWidgetPagesList = createAction(
  '[Widgets/Page] Go to widget pages list',
  props<{ newTab?: boolean | undefined }>(),
)

export const clearWidgetPages = createAction('[WidgetPages/Page] Clear Widget Pages')
